import React, { useEffect, useState } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { get } from '../../services/api'
import { CreditCard, CheckCircle, Clock, XCircle, DollarSign, Calendar, QrCode, AlertCircle, Search, X } from 'lucide-react'
import { toast } from 'react-hot-toast'
import LoadingSpinner from '../../components/common/LoadingSpinner'
import Card from '../../components/common/Card'
import Button from '../../components/common/Button'
import QRModal from '../../components/estudiante/QRModal'
import ReceiptUploadModal from '../../components/estudiante/ReceiptUploadModal'
import { estudianteService } from '../../services/estudianteService'

const Pagos = () => {
  const { user } = useAuth()
  const [pagos, setPagos] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [showQRModal, setShowQRModal] = useState(false)
  const [selectedCuotaId, setSelectedCuotaId] = useState(null)
  const [showReceiptModal, setShowReceiptModal] = useState(false)
  const [selectedReceipt, setSelectedReceipt] = useState(null)
  
  const [busquedaEstudiante, setBusquedaEstudiante] = useState('')
  const [estudiantesFiltrados, setEstudiantesFiltrados] = useState([])
  const [mostraBuscador, setMostraBuscador] = useState(false)
  const [cargandoEstudiantes, setCargandoEstudiantes] = useState(false)
  const [estudianteSeleccionado, setEstudianteSeleccionado] = useState(null)

  const buscarEstudiantes = async () => {
    try {
      setCargandoEstudiantes(true)
      const response = await estudianteService.buscar(busquedaEstudiante)
      
      if (response.success) {
        setEstudiantesFiltrados(response.data || [])
      } else {
        setEstudiantesFiltrados([])
      }
    } catch (error) {
      console.error('Error buscando estudiantes:', error)
      setEstudiantesFiltrados([])
    } finally {
      setCargandoEstudiantes(false)
    }
  }
  const seleccionarEstudiante = (estudiante) => {
    setEstudianteSeleccionado(estudiante)
    setBusquedaEstudiante(`${estudiante.nombre} ${estudiante.apellido}`)
    setEstudiantesFiltrados([])
    setMostraBuscador(false)
  }

  const limpiarEstudiante = () => {
    setEstudianteSeleccionado(null)
    setBusquedaEstudiante('')
    setEstudiantesFiltrados([])
  }
  const fetchPagos = async () => {
    try {
      console.log('💳 Estudiante:', estudianteSeleccionado)
      // setLoading(true)
      // const response = await get('/estudiante/pagos')
      const response = await get(`/admin/pagos/${estudianteSeleccionado?.id}`)
      
      console.log('💳 Respuesta de pagos:', response.data)
      
      if (response.data.success) {
        // El backend retorna: { success: true, data: { cuotas: [...], total_cuotas: ..., ... } }
        let pagosData = []
        
        if (response.data.data) {
          // Si tiene la propiedad cuotas dentro de data
          if (response.data.data.cuotas && Array.isArray(response.data.data.cuotas)) {
            pagosData = response.data.data.cuotas
          } 
          // Si tiene la propiedad pagos dentro de data
          else if (response.data.data.pagos && Array.isArray(response.data.data.pagos)) {
            pagosData = response.data.data.pagos
          }
          // Si es un array directo
          else if (Array.isArray(response.data.data)) {
            pagosData = response.data.data
          }
        } 
        // Fallback: buscar directamente en response.data
        else if (response.data.cuotas && Array.isArray(response.data.cuotas)) {
          pagosData = response.data.cuotas
        } else if (response.data.pagos && Array.isArray(response.data.pagos)) {
          pagosData = response.data.pagos
        }
        
        // Asegurar que siempre sea un array
        if (!Array.isArray(pagosData)) {
          console.warn('⚠️ pagosData no es un array:', pagosData)
          pagosData = []
        }
        
        setPagos(pagosData)
      } else {
        setError('No se pudieron cargar los pagos')
        setPagos([])
      }
    } catch (error) {
      console.error('Error cargando pagos:', error)
      setError('Error al cargar los pagos')
      setPagos([])
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (estudianteSeleccionado) {
      fetchPagos();
    }
  }, [estudianteSeleccionado]);

  // Buscar estudiantes mientras escriben
  useEffect(() => {
    if (busquedaEstudiante.trim().length >= 2) {
      buscarEstudiantes()
    } else {
      setEstudiantesFiltrados([])
    }
  }, [busquedaEstudiante])
  const getEstadoBadge = (estado) => {
    switch (estado?.toLowerCase()) {
      case 'pagado':
      case 'verificado':
        return (
          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
            <CheckCircle className="h-4 w-4" />
            Pagado
          </span>
        )
      case 'pendiente':
        return (
          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-yellow-100 text-yellow-800">
            <Clock className="h-4 w-4" />
            Pendiente
          </span>
        )
      case 'rechazado':
      case 'cancelado':
        return (
          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
            <XCircle className="h-4 w-4" />
            Rechazado
          </span>
        )
      default:
        return (
          <span className="inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-medium bg-gray-100 text-gray-800">
            {estado || 'Sin estado'}
          </span>
        )
    }
  }

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('es-BO', {
      style: 'currency',
      currency: 'BOB'
    }).format(amount || 0)
  }

  // if (loading) {
  //   return (
  //     <div className="flex items-center justify-center min-h-[400px]">
  //       <LoadingSpinner />
  //     </div>
  //   )
  // }

  if (error) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <p className="text-red-800">{error}</p>
      </div>
    )
  }

  const pagosPendientes = Array.isArray(pagos) ? pagos.filter(p => p.estado?.toLowerCase() === 'pendiente') : []
  const totalPendiente = pagosPendientes.reduce((sum, p) => sum + (parseFloat(p.monto) || 0), 0)

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="bg-gradient-to-r from-green-600 to-green-700 rounded-lg p-6 text-white">
        <h1 className="text-3xl font-bold mb-2 flex items-center gap-3">
          <CreditCard className="h-8 w-8" />
          Registrar Pagos
        </h1>
        <p className="text-green-100">
          Consulta y gestiona pagos y cuotas académicas
        </p>
      </div>
      {/* Buscador de Estudiantes */}
      <Card className="gradient" shadow="glow-lg">
        <div className="mb-4">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-3 flex items-center gap-2">
            <Search className="h-5 w-5" />
            Buscar Estudiante
          </h3>
        </div>

        <div className="relative mb-4">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
            <input
              type="text"
              placeholder="Busca por nombre, cédula o número de documento..."
              value={busquedaEstudiante}
              onChange={(e) => {
                setBusquedaEstudiante(e.target.value)
                setMostraBuscador(true)
              }}
              onFocus={() => setMostraBuscador(true)}
              className="w-full pl-10 pr-10 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 dark:bg-gray-700 dark:text-white"
            />
            {busquedaEstudiante && (
              <button
                onClick={() => limpiarEstudiante()}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
              >
                <X className="h-5 w-5" />
              </button>
            )}
          </div>

          {/* Dropdown de autocompletado */}
          {mostraBuscador && (busquedaEstudiante.length >= 2 || estudiantesFiltrados.length > 0) && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-lg shadow-lg z-50 max-h-96 overflow-y-auto">
              {cargandoEstudiantes ? (
                <div className="p-4 text-center">
                  <div className="inline-block">
                    <LoadingSpinner size="sm" />
                  </div>
                </div>
              ) : estudiantesFiltrados.length > 0 ? (
                <ul>
                  {estudiantesFiltrados.map((estudiante) => (
                    <li key={estudiante.id}>
                      <button
                        onClick={() => seleccionarEstudiante(estudiante)}
                        className="w-full text-left px-4 py-3 hover:bg-gray-100 dark:hover:bg-gray-700 border-b border-gray-200 dark:border-gray-700 last:border-b-0 transition-colors"
                      >
                        <div className="font-semibold text-gray-900 dark:text-gray-100">
                          {estudiante.nombre} {estudiante.apellido}
                        </div>
                        <div className="text-sm text-gray-600 dark:text-gray-400">
                          Cédula: {estudiante.ci} | Doc: {estudiante.numero_documento}
                        </div>
                      </button>
                    </li>
                  ))}
                </ul>
              ) : busquedaEstudiante.length >= 2 ? (
                <div className="p-4 text-center text-gray-500 dark:text-gray-400">
                  No se encontraron estudiantes
                </div>
              ) : null}
            </div>
          )}
        </div>

        {/* Panel de datos del estudiante seleccionado */}
        {estudianteSeleccionado && (
          <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-200 dark:border-blue-800 rounded-lg">
            <div className="flex justify-between items-start mb-4">
              <h4 className="font-semibold text-gray-900 dark:text-gray-100">
                Datos del Estudiante
              </h4>
              <button
                onClick={() => limpiarEstudiante()}
                className="text-gray-500 hover:text-gray-700 dark:hover:text-gray-300"
              >
                <X className="h-5 w-5" />
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
              <div>
                <p className="text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wide">Nombre</p>
                <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                  {estudianteSeleccionado.nombre} {estudianteSeleccionado.apellido}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wide">Cédula de Identidad</p>
                <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                  {estudianteSeleccionado.ci}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wide">Número de Documento</p>
                <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                  {estudianteSeleccionado.numero_documento}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wide">Sexo</p>
                <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                  {estudianteSeleccionado.sexo === 'M' ? 'Masculino' : estudianteSeleccionado.sexo === 'F' ? 'Femenino' : estudianteSeleccionado.sexo}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wide">Fecha de Nacimiento</p>
                <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                  {new Date(estudianteSeleccionado.fecha_nacimiento).toLocaleDateString()}
                </p>
              </div>

              <div>
                <p className="text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wide">Celular</p>
                <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                  {estudianteSeleccionado.celular}
                </p>
              </div>

              <div className="sm:col-span-2">
                <p className="text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wide">Dirección</p>
                <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                  {estudianteSeleccionado.direccion}
                </p>
              </div>

              {estudianteSeleccionado.registro_estudiante && (
                <div>
                  <p className="text-xs text-gray-600 dark:text-gray-400 uppercase tracking-wide">Registro de Estudiante</p>
                  <p className="text-sm font-semibold text-gray-900 dark:text-gray-100">
                    {estudianteSeleccionado.registro_estudiante}
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </Card>
      {/* Resumen */}
      {pagosPendientes.length > 0 && (
        <Card className="bg-yellow-50 border-yellow-200">
          <div className="p-4">
            <div className="flex items-center justify-between">
              <div>
                <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 text-gray-900 mb-1">
                  Pagos Pendientes
                </h3>
                <p className="text-gray-600 text-gray-900 dark:text-gray-100">
                  Tienes {pagosPendientes.length} {pagosPendientes.length === 1 ? 'pago' : 'pagos'} pendiente{pagosPendientes.length > 1 ? 's' : ''}
                </p>
              </div>
              <div className="text-right">
                <p className="text-2xl font-bold text-yellow-700">
                  {formatCurrency(totalPendiente)}
                </p>
                <p className="text-sm text-gray-600">Total pendiente</p>
              </div>
            </div>
          </div>
        </Card>
      )}

      {/* Lista de Pagos */}
      {!Array.isArray(pagos) || pagos.length === 0 ? (
        <Card>
          <div className="text-center py-12">
            <CreditCard className="h-16 w-16 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              No tienes pagos registrados
            </h3>
            <p className="text-gray-600">
              Los pagos aparecerán aquí cuando se generen cuotas académicas
            </p>
          </div>
        </Card>
      ) : (
        <div className="grid gap-6">
          {Array.isArray(pagos) && pagos.map((pago, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow">
              <div className="p-6">
                <div className="flex items-start justify-between mb-4">
                  <div className="flex-1">
                    <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2">
                      {pago.concepto || pago.descripcion || 'Pago académico'}
                    </h3>
                    {pago.programa && (
                      <p className="text-gray-600 text-sm mb-2 text-gray-900 dark:text-gray-100">
                        Programa: {pago.programa.nombre || pago.programa}
                      </p>
                    )}
                    {pago.fecha_vencimiento && (
                      <p className="text-gray-500 text-xs flex items-center gap-1 text-gray-900 dark:text-gray-100">
                        <Calendar className="h-4 w-4" />
                        Vence: {new Date(pago.fecha_vencimiento).toLocaleDateString()}
                      </p>
                    )}
                  </div>
                  <div className="text-right">
                    <div className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">
                      {formatCurrency(pago.monto)}
                    </div>
                    {getEstadoBadge(pago.estado)}
                  </div>
                </div>

                {pago.fecha_pago && (
                  <div className="mt-4 pt-4 border-t border-gray-200">
                    <p className="text-sm text-gray-600">
                      <strong>Fecha de pago:</strong> {new Date(pago.fecha_pago).toLocaleDateString()}
                    </p>
                  </div>
                )}

                {pago.estado?.toLowerCase() === 'pendiente' && (
                  <div className="mt-4 pt-4 border-t border-gray-200">
                    <div className="flex items-center gap-3 flex-wrap">
                      <Button
                        variant="primary"
                        size="sm"
                        onClick={() => {
                          if (pago.cuota_id || pago.id) {
                            setSelectedCuotaId(pago.cuota_id || pago.id)
                            setShowQRModal(true)
                          } else {
                            toast.error('No se pudo obtener la información de la cuota')
                          }
                        }}
                      >
                        <QrCode className="h-4 w-4 mr-2" />
                        Pagar con QR
                      </Button>
                      <Button
                        variant="outline"
                        size="sm"
                        onClick={() => {
                          setSelectedReceipt({
                            cuotaId: pago.cuota_id || pago.id,
                            monto: pago.monto,
                            saldoPendiente: pago.saldo_pendiente || pago.monto
                          })
                          setShowReceiptModal(true)
                        }}
                      >
                        <CreditCard className="h-4 w-4 mr-2" />
                        Subir Comprobante
                      </Button>
                    </div>
                    <div className="mt-3 p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                      <div className="flex items-start gap-2">
                        <AlertCircle className="h-5 w-5 text-yellow-600 mt-0.5 flex-shrink-0" />
                        <div className="text-sm text-yellow-800">
                          <p className="font-medium mb-1">Importante:</p>
                          <p>Después de realizar el pago, sube el comprobante para que sea verificado. Tu inscripción se validará una vez que el pago sea confirmado.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </Card>
          ))}
        </div>
      )}

      {/* Modal de QR */}
      <QRModal
        isOpen={showQRModal}
        onClose={() => {
          setShowQRModal(false)
          setSelectedCuotaId(null)
        }}
        cuotaId={selectedCuotaId}
        urlInfoQr={
          estudianteSeleccionado && selectedCuotaId
            ? `/admin/pagos/${estudianteSeleccionado.id}/${selectedCuotaId}/info-qr`
            : ''
        }
      />

      {/* Modal de Subida de Comprobante */}
      <ReceiptUploadModal
        isOpen={showReceiptModal}
        onClose={() => {
          setShowReceiptModal(false)
          setSelectedReceipt(null)
        }}
        cuotaId={selectedReceipt?.cuotaId}
        monto={selectedReceipt?.monto}
        saldoPendiente={selectedReceipt?.saldoPendiente}
        onSuccess={() => {
          // Recargar pagos después de subir comprobante
          fetchPagos()
        }}
        urlPago={estudianteSeleccionado && selectedReceipt?.cuotaId ? `/admin/pagos` : ''}
        estudianteId={estudianteSeleccionado?.id}
      />
    </div>
  )
}

export default Pagos

